import React, { createContext, useContext } from 'react';
import type { Participant } from './types';

/**
 * Thread 안 컴포넌트 (ThreadShell, MessageItem, 어댑터들) 공유 컨텍스트.
 *
 * - participants: revoked 포함 (탈퇴자도 sender 매칭에 필요).
 * - viewerPeerHash: 현재 사용자 hash — 본인 메시지 식별.
 * - onPeerClick: peer 항목 클릭 시 — PeerInfoModal 띄움.
 * - onFamilyClick: family 항목 클릭 시 — /mofamily/:hash navigate.
 */
export interface MessagesContextValue {
 participants: Participant[];
 viewerPeerHash: string;
 onPeerClick: (peer: Participant) => void;
 onFamilyClick: (familyHash: string) => void;
}

const Ctx = createContext<MessagesContextValue | null>(null);

export const MessagesProvider: React.FC<{ value: MessagesContextValue; children: React.ReactNode }> = ({ value, children }) => (
 <Ctx.Provider value={value}>{children}</Ctx.Provider>
);

export function useMessagesContext(): MessagesContextValue {
 const ctx = useContext(Ctx);
 if (!ctx) throw new Error('useMessagesContext outside of MessagesProvider');
 return ctx;
}

/** sender_peer_hash 로 participants 매핑 — 탈퇴자도 검색. */
export function findSenderParticipant(participants: Participant[], senderPeerHash: string | null): Participant | undefined {
 if (!senderPeerHash) return undefined;
 return participants.find(p => p.peer_hash === senderPeerHash || p.acting_peer_hash === senderPeerHash);
}
